// Central registry of test IDs used by the automated testing agent.
export const APP = {
  themeToggle: 'app-theme-toggle',
  logoLink: 'app-logo-link',
  navDashboard: 'nav-dashboard',
  navAssessments: 'nav-assessments',
  navCompetitors: 'nav-competitors',
  navContent: 'nav-content',
  navSimulator: 'nav-simulator',
  navGraph: 'nav-graph',
  navMarketplace: 'nav-marketplace',
  navReports: 'nav-reports',
  navAgents: 'nav-agents',
  navSettings: 'nav-settings',
  clientPicker: 'client-picker',
  signOut: 'sign-out-button',
};

export const LANDING = {
  ctaPrimary: 'landing-cta-primary',
  ctaSecondary: 'landing-cta-secondary',
  loginLink: 'landing-login-link',
  heroHeadline: 'landing-hero-headline',
  featureSection: 'landing-features',
};

export const AUTH = {
  googleLogin: 'auth-google-login-button',
  loginBackLink: 'auth-back-link',
};

export const ONBOARDING = {
  next: 'onboarding-next',
  back: 'onboarding-back',
  submit: 'onboarding-submit',
  companyName: 'onboarding-company-name',
  website: 'onboarding-website',
  industry: 'onboarding-industry',
  competitors: 'onboarding-competitors',
};

export const DASHBOARD = {
  scoreCard: 'dashboard-score-card',
  certificationBadge: 'dashboard-certification-badge',
  trendChart: 'dashboard-trend-chart',
  subScoreGrid: 'dashboard-subscore-grid',
  manusBriefBtn: 'dashboard-manus-brief-btn',
};

export const ASSESS = {
  runAeo: 'assess-run-aeo',
  runAir: 'assess-run-air',
  aeoResult: 'assess-aeo-result',
  airResult: 'assess-air-result',
};

export const COMPETITORS = {
  scanBtn: 'competitors-scan-btn',
  resultsList: 'competitors-results-list',
};

export const CONTENT = {
  generateBtn: 'content-generate-btn',
  typeSelect: 'content-type-select',
  topicInput: 'content-topic-input',
  list: 'content-list',
};

export const SIMULATOR = {
  runBtn: 'simulator-run-btn',
  reviewsSlider: 'simulator-reviews-slider',
  podcastsSlider: 'simulator-podcasts-slider',
  backlinksSlider: 'simulator-backlinks-slider',
  resultCard: 'simulator-result-card',
};
